import { render, staticRenderFns } from "./PickupModal.vue?vue&type=template&id=29de01c6&"
import script from "./PickupModal.vue?vue&type=script&lang=js&"
export * from "./PickupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports